import { ViewState } from '@devexpress/dx-react-scheduler'
import { Appointments, DayView, Scheduler } from '@devexpress/dx-react-scheduler-material-ui'
import React from 'react'

import { usePlannerContext } from '@/context'
import { PlannerItemResponse } from '@/types/Planner'
import { formatDate, parseDate } from '@/util'
import { getPlannerDataForCalendar, getUnscheduledDataForDay } from '@/util/PlannerUtil'

import { getWeeklyList } from '../ListView/ListView.data'
import UnscheduledDayItems from './UnscheduledDayItems'

const renderEvent = ({ children, data, onClick, ...restProps }: Appointments.AppointmentProps, onEventClick) => {
  return (
    <Appointments.Appointment
      data={data}
      onClick={(e) => onEventClick(e.data)}
      style={{ backgroundColor: data.color, borderRadius: 8 }}
      {...restProps}
    >
      {children}
    </Appointments.Appointment>
  )
}

const EventContent = ({
  formatDate,
  children,
  data,
  durationType,
  ...restProps
}: Appointments.AppointmentContentProps) => {
  return (
    <div>
      <Appointments.AppointmentContent
        data={data}
        durationType={durationType}
        formatDate={formatEventDate}
        style={{ paddingTop: 4, paddingBottom: 4, paddingLeft: 6, paddingRight: 6, textTransform: 'capitalize' }}
        {...restProps}
      >
        {children}
      </Appointments.AppointmentContent>
      {durationType === 'long' && (
        <div className="rounded-md bg-white px-2 absolute bottom-4 left-4" style={{ fontSize: 11 }}>
          {data.taskType}
        </div>
      )}
    </div>
  )
}

const formatEventDate = (nextDate: Date | string | number | undefined) => {
  return formatDate(parseDate(nextDate), 'hh:mma') || 'Invalid Date'
}

const DayRow = (props) => {
  return <DayView.TimeTableCell {...props} style={{ borderBottom: '1px dashed #CECDCA' }}></DayView.TimeTableCell>
}

type Props = {
  data: PlannerItemResponse[] | undefined
  onEventClick: (event: any) => void
}

export const DayCalendar = ({ data, onEventClick }: Props) => {
  const { selectedDate, startWeekDate, endWeekDate, setDate } = usePlannerContext()
  const formattedSelectedDate = formatDate(selectedDate, 'yyyy-MM-dd') as string
  const weeklyList = getWeeklyList(startWeekDate, endWeekDate, data)

  const changeDate = (dateString: string | null) => {
    const date = parseDate(dateString, 'yyyy-MM-dd')
    date && setDate(date)
  }

  const dayCalendarData = data ? getPlannerDataForCalendar(data) : []
  const unscheduledData = data ? getUnscheduledDataForDay(data, selectedDate) : []

  return (
    <div className="flex w-full flex-col">
      <div className="mb-3 flex w-full justify-between px-2">
        {weeklyList &&
          weeklyList.map((day, index) => {
            return (
              <div
                className={`flex flex-col items-center px-2 py-3 ${
                  day.fullDate == formattedSelectedDate ? 'rounded-md  bg-emphasis' : ''
                }`}
                key={index}
                onClick={() => changeDate(day.fullDate)}
                role={'presentation'}
              >
                <p className="text-xl leading-120">{day.date}</p>
                <p className="text-p-xs text-tertiary">{day.day}</p>
              </div>
            )
          })}
      </div>
      <UnscheduledDayItems data={unscheduledData} onItemClick={onEventClick} />
      <Scheduler data={dayCalendarData}>
        <ViewState currentDate={selectedDate || undefined} />
        <DayView
          cellDuration={30}
          dayScaleCellComponent={() => null}
          endDayHour={22}
          startDayHour={7}
          timeTableCellComponent={DayRow}
        />
        <Appointments
          appointmentComponent={(props) => renderEvent(props, onEventClick)}
          appointmentContentComponent={EventContent}
        />
      </Scheduler>
    </div>
  )
}
